export default function getQueryString(name){
    // 获取URL参数
    let search = window.location.search + window.location.hash;
    let reg = new RegExp("[?&]" + name + "=([\\w%#-]*)", "ig");
    let result = reg.exec(search);
    return result ? decodeURIComponent(result[1]) : null;
}